const COOKIE_NAME = 'pepoll_referral';
const MAX_AGE_SECONDS = 2592000; // 30 days

export function saveReferralCookie(code: string): void {
  if (getReferralCode() !== null) return;
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(code)}; path=/; max-age=${MAX_AGE_SECONDS}; samesite=lax`;
}

export function getReferralCode(): string | null {
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${COOKIE_NAME}=`));
  if (!match) return null;
  return decodeURIComponent(match.split('=')[1]);
}
